import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currBalance:null,
    isOpenModalEarnReward:false,
    objDataRedeemReward:{
      id:null,
      title:"",
      image:"",
      redeem_code:""
    },
    isOpenSnack:false,
    snackMessage:"",
    isCopy:false,
    snackBarTime:0,
    reFetchBalanceProfile:false
}

export const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    setCurrBalance: (state, action) => {
      state.currBalance = action.payload;
    },
    setOpenModalEarnReward: (state, action) => {
      state.isOpenModalEarnReward = action.payload;
    },
    setDataRedeemReward: (state, action) => {
      state.objDataRedeemReward = action.payload;
    },
    setIsOpenSnack: (state, action) => {
      state.isOpenSnack = action.payload;
    },
    setSnackMessage: (state, action) => {
      state.snackMessage = action.payload;
    },
    setIsCopy: (state, action) => {
      state.isCopy = action.payload;
    },
    setSnackBarTime: (state, action) => {
      state.snackBarTime = action.payload;
    },
    setRefetchBalanceProfile: (state, action) => {
      state.reFetchBalanceProfile = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setCurrBalance, setOpenModalEarnReward, setDataRedeemReward, setIsOpenSnack, setSnackMessage, setIsCopy, setSnackBarTime, setRefetchBalanceProfile } = rewardsSlice.actions

export default rewardsSlice.reducer